export const selectCurrentItem = (state) => state.items.items[state.items.currentItem];
export const selectItemAtIndex = (index) => (state) => state.items.items[index];
